import { useParams } from 'react-router-dom';
import { lazy, Suspense } from 'react';
import navConfig from './navConfig.json';
import ProfileNav from './ProfileNav.jsx';
import { TabsUiFrame } from './tabs_ui.jsx';

// Tìm route trong cấp items và children
function matchesSlug(configValue, currentValue) {
  if (Array.isArray(configValue)) {
    return configValue.includes(currentValue);
  }
  return configValue === currentValue;
}

function findRouteBySlug(slug_1, items) {
  for (const item of items) {
    if (matchesSlug(item.slug_1, slug_1)) {
      return item;
    }
    if (item.children) {
      const child = item.children.find(c => matchesSlug(c.slug_1, slug_1));
      if (child) {
        return child;
      }
    }
  }
  return null;
}

// component Home nhận vào category (từ route props) và lấy slug_1 từ useParams
function Home({ category, slug_1: slug1Override, slug_2: slug2Override, slug_3: slug3Override, slug_4: slug4Override }) {
  const params = useParams();
  const slug_1 = slug1Override ?? params.slug_1;
  const slug_2 = slug2Override ?? params.slug_2;
  const slug_3 = slug3Override ?? params.slug_3;
  const slug_4 = slug4Override ?? params.slug_4;

  // Tìm cấu hình category
  const categoryConfig = navConfig.find(cat => cat.category === category);
  if (!categoryConfig) {
    return <div>Không tìm thấy danh mục: {category}</div>;
  }

  // Lấy danh sách items trong danh mục
  const items = categoryConfig.items;

  // Tìm route tương ứng theo slug_1
  let currentRoute = findRouteBySlug(slug_1, items);
  if (category == 'check_scam') {
  } else if (!currentRoute) {
    return <div>Không tìm thấy trang: {slug_1}</div>;
  }

  return (
    <>
      <TabsUiFrame>
        <ProfileNav category={category} slug_1={slug_1} slug_2={slug_2} slug_3={slug_3} slug_4={slug_4} />
      </TabsUiFrame>
    </>
  );
}

export default Home;
